// -----------------------------------------------------------------------------
// Hilfreiche Funktionen für String
// -----------------------------------------------------------------------------

/**
 * Gibt String mit großem Anfangsbuchstaben zurück
 * @see https://stackoverflow.com/a/1026087/6808559
 *
 * @param input
 * @param locale
 * @returns {*}
 */
const ucfirst = (input, locale = navigator.language) => {
  // Abbruch, falls kein String übergeben wurde
  if (typeof input !== 'string') {
    return '';
  }

  const first = input[0];
  const rest = Array.from(input);
  rest.shift();

  return first.toLocaleUpperCase(locale) + rest.join('');
};

/**
 * E-Mail-Adresse validieren
 *
 * @see https://stackoverflow.com/a/42965760/6808559
 * @param email
 * @returns {boolean}
 */
const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export {
  ucfirst,
  validateEmail
};
